export default "__VITE_ASSET__BrUGt6Os__"